<template>
	<div class="manage">
		<div style="" class="top">
			<el-row>
				<!--  -->
				<el-col :span="1">
					<el-input v-model="page_size" @blur="ps_input" style="" placeholder="行数" clearable>
					</el-input>
				</el-col>
				<el-col :span="2">
					<el-input v-model="form.brand_name" style="" placeholder="品牌" clearable>
					</el-input>
				</el-col>
				<el-col :span="2">
					<el-input v-model="form.name" style="" placeholder="品名" clearable>
					</el-input>
				</el-col>
				<el-col :span="2">
					<el-input v-model="form.model_order_no" style="" placeholder="型号或订货号" clearable>
					</el-input>
				</el-col>
				<el-col :span="2">
					<el-select v-model="form.stock_type_txt" placeholder="货物类型" clearable>
						<el-option v-for="item in stocktype_list" :key="item.name" :label="item.name"
							:value="item.name" />
					</el-select>
				</el-col>
				<el-col :span="2">
					<el-select v-model="form.is_import" placeholder="数据类型" clearable>
						<el-option v-for="item in is_import_list" :key="item.value" :label="item.text"
							:value="item.value" />
					</el-select>
				</el-col>
				<el-col :span="2">
					<el-input v-model="form.goods_shelf" style="" placeholder="货架" clearable>

					</el-input>
				</el-col>
				<el-col :xs="24" :sm="7" :md="7" :lg="7" :xl="6" style="text-align:left">
					<el-button color="#ff8a5c" style="color:#fff;margin-left: 0rem;" @click="grabble">
						<el-icon color="#fff" size="12px" class="no-inherit">
							<Search />
						</el-icon>
					</el-button>
					<el-button color="#ff8a5c" style="color:#fff;margin-left: 0.75rem;" @click="newBuild">新建</el-button>
					<el-button color="#ff8a5c" style="color:#fff" @click="showLeadin_click">导入</el-button>
					<el-button color="#ff8a5c" style="color:#fff;margin-left: 0.75rem;"
						@click="updatestorage">保存</el-button>

					<el-button type="danger" @click="del">删除</el-button>

				</el-col>
				<!-- <el-col :xs="11" :sm="11" :md="11" :lg="11" :xl="11">
					<el-input v-model="form.value" placeholder="请输入产品名称/品牌/型号/订货号">
						<template #append>
							<el-button type="primary" class="button" style="width:60px" @click="grabble">
								<el-icon color="#fff" size="12px" class="no-inherit">
									<Search />
								</el-icon>
							</el-button>
						</template>
</el-input>
</el-col> -->
				<el-col :xs="24" :sm="4" :md="4" :lg="4" :xl="5" style="text-align:right">
					<el-button color="#ff8a5c" style="color:#fff" @click="circulation">转定价</el-button>

					<!-- <el-button color="#ff8a5c" style="color:#fff" @click="checkstorage()">校对</el-button> -->
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="24" class="table">
					<div ref="height_top" class='singleTable'>
						<!-- <el-table-v2
					    :columns="columns"
					    :data="cccc"
					    :width="700"
					    :height="400"
					    fixed
					  /> -->
						<el-table :data="tableData" ref="singleTable" :row-key="getId" @cell-click="tabClick"
							@row-click="rowClick" :row-style="addStyle" :row-class-name="tableRowClassName"
							@selection-change="handleSelectionChange" :height="tableHeight" v-loading="loading"
							:header-cell-style="{ 'background-color': '#e5e5e5' }" size="small" style="width: 100%">
							<el-table-column type="selection" width="55" :selectable="selectable" />
							<el-table-column prop="img" label="图片" width="70" show-overflow-tooltip column-key="img"
								:filters="[
									{ text: '有图', value: '1' },
									{ text: '无图', value: '2' },
								]">
								<template #default="scope">
									<div v-if="scope.row.ass_num">
										<el-badge :max="10" :value="scope.row.ass_num" class="item"
											:offset="[(scope.row.ass_num > 10) ? -1 : 1, 9]">
											<div v-if="scope.row.img.length <= 0">
												<!--  -->
												<el-icon size="20" style="top: 0.3rem;">
													<PictureFilled />
												</el-icon>
											</div>
											<div v-else>
												<el-icon size="20" style=" color: #29afa5; top: 0.3rem;"
													@click="preview(scope.row, scope.row.img)">
													<PictureFilled />
												</el-icon>
											</div>
										</el-badge>
									</div>
									<div v-else>
										<div v-if="scope.row.img.length <= 0">
											<!--  -->
											<el-icon size="20" style="top: 0.3rem;">
												<PictureFilled />
											</el-icon>
										</div>
										<div v-else>
											<el-icon size="20" style=" color: #29afa5; top: 0.3rem;"
												@click="preview(scope.row, scope.row.img)">
												<PictureFilled />
											</el-icon>
										</div>
									</div>
								</template>
							</el-table-column>
							<el-table-column prop="brand_name" label="*品牌" width="" show-overflow-tooltip>
								<template #header>
									<span style="color:red">
										*
									</span>
									<span>
										品牌
									</span>
								</template>
								<template #default="scope">
									<span
										v-if="scope.row.index === tabClickIndex && tabClickcolumn == '4' && scope.row.is_import != 2"
										@click.stop>
										<el-input v-bind:class="{ 'row_input': row_input !== scope.row.index + '4' }"
											:ref="'save_input' + scope.row.index + '4'"
											:id="'save_input' + scope.row.index + '4'" v-model="scope.row.brand_name"
											maxlength="300" size="mini"
											@blur="facePriceblur($event, scope.row, scope.row.index, 'brand_name')"
											@focus="inputfocus(scope.row.index + '4', $event)" />
									</span>
									<span v-else>
										{{ scope.row.brand_name }}
									</span>
								</template>
							</el-table-column>
							<el-table-column prop="name" label="品名" width="" show-overflow-tooltip>
								<template #default="scope">
									<span
										v-if="scope.row.index === tabClickIndex && tabClickcolumn == '5' && scope.row.is_import != 2"
										@click.stop>
										<el-input v-bind:class="{ 'row_input': row_input !== scope.row.index + '5' }"
											:ref="'save_input' + scope.row.index + '5'"
											:id="'save_input' + scope.row.index + '5'" v-model="scope.row.name"
											maxlength="300" size="mini"
											@blur="facePriceblur($event, scope.row, scope.row.index, 'name')"
											@focus="inputfocus(scope.row.index + '5', $event)" />
									</span>
									<span v-else>
										{{ scope.row.name }}
									</span>
								</template>
							</el-table-column>
							<el-table-column prop="model" label="*型号" width="" show-overflow-tooltip>
								<template #header>
									<span style="color:red">
										*
									</span>
									<span>
										型号
									</span>
								</template>
								<template #default="scope">
									<span
										v-if="scope.row.index === tabClickIndex && tabClickcolumn == '6' && scope.row.is_import != 2"
										@click.stop>
										<el-input style="width:80%"
											v-bind:class="{ 'row_input': row_input !== scope.row.index + '6' }"
											:ref="'save_input' + scope.row.index + '6'"
											:id="'save_input' + scope.row.index + '6'" v-model="scope.row.model"
											maxlength="300" size="mini"
											@blur="facePriceblur($event, scope.row, scope.row.index, 'model')"
											@focus="inputfocus(scope.row.index + '6', $event)" />
									</span>
									<span v-else>
										{{ scope.row.model }}
									</span>
									<el-icon v-if="scope.row.is_import != 2" size="20"
										style=" color: #29afa5; position: absolute;right: 0px;top: 8px;"
										@click="dialogTableVisible_goods_show(scope.row)">
										<MoreFilled />
									</el-icon>
								</template>
							</el-table-column>
							<el-table-column prop="order_no" label="订货号" width="" show-overflow-tooltip>
								<template #default="scope">
									<span
										v-if="scope.row.index === tabClickIndex && tabClickcolumn == '7' && scope.row.is_import != 2"
										@click.stop>
										<el-input v-bind:class="{ 'row_input': row_input !== scope.row.index + '5' }"
											:ref="'save_input' + scope.row.index + '7'"
											:id="'save_input' + scope.row.index + '7'" v-model="scope.row.order_no"
											maxlength="300" size="mini"
											@blur="facePriceblur($event, scope.row, scope.row.index, 'order_no')"
											@focus="inputfocus(scope.row.index + '7', $event)" />
									</span>
									<span v-else>
										{{ scope.row.order_no }}
									</span>
								</template>
							</el-table-column>
							<el-table-column prop="num" label="*数量" width="80" align="right" header-align="left"
								show-overflow-tooltip>
								<template #header>
									<span style="color:red">
										*
									</span>
									<span>
										数量
									</span>
								</template>
								<template #default="scope">
									<span
										v-if="scope.row.index === tabClickIndex && tabClickcolumn == '3' && scope.row.is_import != 2"
										@click.stop>
										<el-input v-bind:class="{ 'row_input': row_input !== scope.row.index + '3' }"
											:ref="'save_input' + scope.row.index + '3'"
											:id="'save_input' + scope.row.index + '3'" v-model="scope.row.num"
											maxlength="300" size="mini"
											@blur="facePriceblur($event, scope.row, scope.row.index, 'num')"
											@focus="inputfocus(scope.row.index + '3', $event)"
											@input="inputBlur_num(scope.row.index, $event, scope.row)" />
									</span>
									<span v-else>
										{{ scope.row.num }}
									</span>
								</template>
							</el-table-column>
							<!-- <el-table-column prop="price" label="列表价" width="80" align="right" header-align="left"
								show-overflow-tooltip>
								<template #default="scope">
									<span
										v-if="scope.row.index === tabClickIndex && tabClickcolumn == '8' && scope.row.is_import != 2"
										@click.stop>
										<el-input v-bind:class="{ 'row_input': row_input !== scope.row.index + '8' }"
											:ref="'save_input' + scope.row.index + '8'"
											:id="'save_input' + scope.row.index + '8'" v-model="scope.row.price"
											maxlength="300" size="mini"
											@blur="facePriceblur($event, scope.row, scope.row.index, 'price')"
											@focus="inputfocus(scope.row.index + '8', $event)"
											@input="inputBlur_price(scope.row.index, $event, scope.row)" />
									</span>
									<span v-else>
										{{ scope.row.price }}
									</span>
								</template>
							</el-table-column>
							<el-table-column prop="discount" label="折扣" align="right" header-align="left" width="80"
								show-overflow-tooltip>
								<template #default="scope">
									<span
										v-if="scope.row.index === tabClickIndex && tabClickcolumn == '1' && scope.row.is_import != 2"
										@click.stop>
										<el-input v-bind:class="{ 'row_input': row_input !== scope.row.index + '1' }"
											:ref="'save_input' + scope.row.index + '1'"
											:id="'save_input' + scope.row.index + '1'" v-model="scope.row.discount"
											maxlength="300" size="mini"
											@blur="facePriceblur($event, scope.row, scope.row.index, 'discount')"
											@focus="inputfocus(scope.row.index + '1', $event)"
											@input="inputBlur_discount(scope.row.index, $event, scope.row)" />
									</span>
									<span v-else>
										{{ scope.row.discount }}
									</span>
								</template>
							</el-table-column> -->
							<el-table-column prop="real_price" label="预入单价" align="right" header-align="left" width="80"
								show-overflow-tooltip>
								<template #default="scope">
									<span
										v-if="scope.row.index === tabClickIndex && tabClickcolumn == '2' && scope.row.is_import != 2"
										@click.stop>
										<el-input v-bind:class="{ 'row_input': row_input !== scope.row.index + '2' }"
											:ref="'save_input' + scope.row.index + '2'"
											:id="'save_input' + scope.row.index + '2'" v-model="scope.row.real_price"
											maxlength="300" size="mini"
											@blur="facePriceblur($event, scope.row, scope.row.index, 'real_price')"
											@focus="inputfocus(scope.row.index + '2', $event)"
											@input="inputBlur_real_price(scope.row.index, $event, scope.row)" />
									</span>
									<span v-else>
										{{ scope.row.real_price }}
									</span>
								</template>
							</el-table-column>
							<el-table-column prop="real_money" label="预入金额" align="right" header-align="left" width="80"
								show-overflow-tooltip />
							<el-table-column prop="goods_shelf" label="货架" width="60" show-overflow-tooltip>
								<template #default="scope">
									<span
										v-if="scope.row.index === tabClickIndex && tabClickcolumn == '10' && scope.row.is_import != 2"
										@click.stop>
										<el-input v-bind:class="{ 'row_input': row_input !== scope.row.index + '10' }"
											:ref="'save_input' + scope.row.index + '10'"
											:id="'save_input' + scope.row.index + '10'" v-model="scope.row.goods_shelf"
											maxlength="300" size="mini"
											@blur="facePriceblur($event, scope.row, scope.row.index, 'goods_shelf')"
											@focus="inputfocus(scope.row.index + '10', $event)" />
									</span>
									<span v-else>
										{{ scope.row.goods_shelf }}
									</span>
								</template>
							</el-table-column>
							<el-table-column prop="stock_type_txt" width="120" label="*货物状态" show-overflow-tooltip>
								<template #header>
									<span style="color:red">
										*
									</span>
									<span>
										货物状态
									</span>
								</template>
								<template #default="scope">
									<span v-if="scope.row.index === tabClickIndex && tabClickcolumn == '9'" @click.stop>
										<el-select v-model="scope.row.stock_type_txt"
											@change="updateStorckType($event, scope.row, scope.row.index)">
											<el-option v-for="item in stocktype_list" :key="item.name"
												:label="item.name" :value="item.name" />
										</el-select>
									</span>
									<span v-else>
										<span v-html="convertStatusToHtml(scope.row.stock_type_txt)"></span>
									</span>
								</template>
							</el-table-column>
							<el-table-column prop="is_import" width="90" label="数据类型" show-overflow-tooltip>
								<template #default="scope">
									<span v-if="scope.row.is_import == 1">
										APP
									</span>
									<span v-else-if="scope.row.is_import == 2">
										ERP
									</span>
									<span v-else-if="scope.row.is_import == 3">
										PC新建
									</span>
									<span v-else>
										文档导入
									</span>
								</template>
							</el-table-column>
							<el-table-column prop="remark" label="备注" width="120" show-overflow-tooltip>
								<template #default="scope">
									<span v-if="scope.row.index === tabClickIndex && tabClickcolumn == '11'"
										@click.stop>
										<el-input v-bind:class="{ 'row_input': row_input !== scope.row.index + '11' }"
											:ref="'save_input' + scope.row.index + '11'"
											:id="'save_input' + scope.row.index + '11'" v-model="scope.row.remark"
											maxlength="300" size="mini"
											@blur="facePriceblur($event, scope.row, scope.row.index, 'remark')"
											@focus="inputfocus(scope.row.index + '11', $event)" />
									</span>
									<span v-else>
										{{ scope.row.remark }}
									</span>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</el-col>
				<el-col :span="24" class="page" style="display: flex; justify-content: flex-end;">
					<el-pagination :pager-count="5" size="small" class="pagination" :current-page="page" background
						:page-size="parseInt(page_size)" layout="prev, pager, next"
						@current-change="handleCurrentChange" :total="total">
					</el-pagination>
				</el-col>
			</el-row>
		</div>
		<el-dialog title="批量调入" :close-on-click-modal="false" v-if="showLeadin" v-model="showLeadin" class="plrkDialog">
			<div class="plrkDialog_div">
				<div class="batch_box1">
					<span class="batch_box2">1</span>
					<span class="color_green" @click="cert_addr">下载最新模板</span>
				</div>

				<el-upload class="upload-demo" ref="upload" action="#" :file-list="fileList"
					:http-request="handleRequest" :limit="1" name="pro_list">
					<div class="batch_box1 m0">
						<span class="batch_box2">2</span>
						<span class="color_green">批量上传商品</span>
					</div>
				</el-upload>
				<div class="batch_box1" style="overflow:hidden">
					<span class="batch_box2">备注:</span>
					<span>向Excel模板中添加数据，注意：不能改变模板中的栏目及格式,最多不超过2M!</span>
				</div>
			</div>
		</el-dialog>
		<el-dialog title="未成功数据列表" width="70%" :close-on-click-modal="false" v-if="showLeadin_table"
			v-model="showLeadin_table" class="">
			<el-table :data="no_tableData" v-loading="no_loading" :header-cell-style="{ 'background-color': '#e5e5e5' }"
				size="small" style="width: 100%">
				<el-table-column prop="brand_name" label="品牌" width="120" show-overflow-tooltip />
				<el-table-column prop="name" label="品名" width="" show-overflow-tooltip />
				<el-table-column prop="model" label="型号" width="" show-overflow-tooltip />
				<el-table-column prop="order_no" label="订货号" width="" show-overflow-tooltip />
				<el-table-column prop="price" label="列表价" show-overflow-tooltip />
				<el-table-column prop="discount" label="折扣" show-overflow-tooltip />
				<el-table-column prop="real_price" label="单价" show-overflow-tooltip />
				<el-table-column prop="num" label="数量" show-overflow-tooltip />
				<el-table-column prop="real_money" label="金额" show-overflow-tooltip />
				<el-table-column prop="stock_type_txt" label="货物状态" show-overflow-tooltip />
				<el-table-column prop="remark" label="原因" show-overflow-tooltip>
				</el-table-column>
			</el-table>
		</el-dialog>
		<el-dialog v-model="dialogTableVisible" title="手动校对数据" width="95%" :close-on-click-modal='false'
			:close-on-press-escape='false'>
			<el-row>
				<el-col :span="24">
					<el-select v-model="particulars_form.difference" @change="change_particulars_search"
						placeholder="选择是否有差异数据" style="width: 240px">
						<el-option v-for="item in differenceList" :key="item.id" :label="item.name" :value="item.id" />
					</el-select>
				</el-col>
				<el-col :span="24">
					<el-table :data="particulars_tableData" :height="tableHeight" v-loading="particulars_loading"
						:header-cell-style="{ 'background-color': '#e5e5e5' }" size="small" style="width: 100%">
						<el-table-column label="原数据" header-align="center">
							<el-table-column prop="original_brand_name" label="品牌" width="80" show-overflow-tooltip />
							<el-table-column prop="original_name" label="品名" width="" show-overflow-tooltip />
							<el-table-column prop="original_model" label="型号" width="" show-overflow-tooltip />
							<el-table-column prop="original_order_no" label="订货号" width="" show-overflow-tooltip />
							<el-table-column prop="original_price" label="列表价" align="right" header-align="left"
								show-overflow-tooltip />
							<el-table-column prop="original_discount" label="折扣" align="right" header-align="left"
								show-overflow-tooltip />
							<el-table-column prop="original_real_price" label="单价" align="right" header-align="left"
								show-overflow-tooltip />
							<el-table-column prop="original_num" label="数量" align="right" header-align="left"
								show-overflow-tooltip />
							<el-table-column prop="original_real_money" label="金额" align="right" header-align="left"
								show-overflow-tooltip />
							<el-table-column prop="" label="操作" show-overflow-tooltip>
								<template #default="scope">
									<el-button type="danger" size="small" v-if="!scope.row.present_id"
										@click="undercarriage(scope.row.original_id)">删除</el-button>
								</template>
							</el-table-column>
						</el-table-column>
						<el-table-column label="新数据" header-align="center">
							<el-table-column prop="present_brand_name" label="品牌" width="80" show-overflow-tooltip />
							<el-table-column prop="present_name" label="品名" width="" show-overflow-tooltip />
							<el-table-column prop="present_model" label="型号" width="" show-overflow-tooltip />
							<el-table-column prop="present_order_no" label="订货号" width="" show-overflow-tooltip />
							<el-table-column prop="present_price" label="列表价" align="right" header-align="left"
								show-overflow-tooltip />
							<el-table-column prop="present_discount" label="折扣" align="right" header-align="left"
								show-overflow-tooltip />
							<el-table-column prop="present_real_price" label="单价" align="right" header-align="left"
								show-overflow-tooltip />
							<el-table-column prop="present_num" label="数量" align="right" header-align="left"
								show-overflow-tooltip />
							<el-table-column prop="present_real_money" label="金额" align="right" header-align="left"
								show-overflow-tooltip />
							<el-table-column prop="" label="操作" show-overflow-tooltip>
								<template #default="scope">
									<el-button type="success" size="small"
										v-if="scope.row.present_id && particulars_form.difference == 2"
										@click="substitute(scope.row.original_id, scope.row.present_id)">替换</el-button>
								</template>
							</el-table-column>
						</el-table-column>
					</el-table>
				</el-col>
				<el-col :span="24" class="page" style="display: flex; justify-content: flex-end;">
					<el-pagination :pager-count="5" size="small" class="pagination" :current-page="particulars_page"
						background :page-size="particulars_page_size" layout="prev, pager, next"
						@current-change="particulars_handleCurrentChange" :total="particulars_total">
					</el-pagination>
				</el-col>
			</el-row>
		</el-dialog>
		<el-dialog v-model="dialogTableVisible_goods" v-if="dialogTableVisible_goods" title="调入商品库" width="95%"
			:close-on-click-modal='false' :close-on-press-escape='false'>
			<el-row :gutter="20" s>
				<el-col :span="7">
					<el-carousel :height="tableHeight + 'px'" style="text-align: center;">
						<el-carousel-item v-for="(item, key) in goods_data.img">
							<img :src="item" height="100%" alt="">
						</el-carousel-item>
					</el-carousel>
				</el-col>
				<el-col :span="13">
					<el-col :span="24">
						<el-table @row-click="particulars_goods_rowClick" :row-style="particulars_goods_addStyle"
							:row-class-name="particulars_goods_tableRowClassName" @row-dblclick="rowDblclickGoods"
							:data="particulars_goods_tableData" :height="tableHeight"
							v-loading="particulars_goods_loading" :header-cell-style="{ 'background-color': '#e5e5e5' }"
							size="small" style="width: 100%">
							<el-table-column prop="brand_name" label="品牌" width="120" show-overflow-tooltip />
							<el-table-column prop="name" label="品名" width="" show-overflow-tooltip />
							<el-table-column prop="model" label="型号" width="" show-overflow-tooltip />
							<el-table-column prop="order_no" label="订货号" width="" show-overflow-tooltip />
							<el-table-column prop="price" label="列表价" width="120" show-overflow-tooltip />
							<el-table-column prop="product_time" width="120" label="列表价年份" show-overflow-tooltip />
						</el-table>
					</el-col>
					<el-col :span="24" class="page" style="display: flex; justify-content: flex-end;">
						<el-pagination :pager-count="5" size="small" class="pagination"
							:current-page="particulars_goods_page" background :page-size="particulars_goods_page_size"
							layout="prev, pager, next" @current-change="particulars_goods_handleCurrentChange"
							:total="particulars_goods_total">
						</el-pagination>
					</el-col>
				</el-col>
				<el-col :span="4">
					<div class="search_box_enq">
						<div class="empty" @click="empty">清空</div>
						<table class="search_tab" border="1" cellspacing="0" cellpadding="0" bordercolor="#e6e6e6">
							<tr>
								<td align="right" class="uppercase">品牌：</td>
								<td>
									<el-input v-model="search_val.brand_name" @keyup.enter.native="onSubmit"></el-input>
								</td>
							</tr>
							<tr>
								<td align="right">系列：</td>
								<td>
									<el-input v-model="search_val.series" @keyup.enter.native="onSubmit"></el-input>
								</td>
							</tr>
							<tr>
								<td align="right">品名：</td>
								<td>
									<el-input v-model="search_val.name" @keyup.enter.native="onSubmit"></el-input>
								</td>
							</tr>
							<tr>
								<td align="right" class="uppercase">型号：</td>
								<td>
									<el-input v-model="search_val.model" @keyup.enter.native="onSubmit"></el-input>
								</td>
							</tr>
							<tr>
								<td align="right" class="uppercase">订货号：</td>
								<td>
									<el-input v-model="search_val.order_no" @keyup.enter.native="onSubmit"></el-input>
								</td>
							</tr>
							<!-- <tr>
	                        <td align="right">时间起：</td>
	                        <td>
	                            <el-date-picker v-model="search_val.starttime_bills" type="date" value-format="yyyy-MM-dd" clearable>
	                            </el-date-picker>
	                        </td>
	                    </tr>
	                    <tr>
	                        <td align="right">时间止：</td>
	                        <td>
	                            <el-date-picker v-model="search_val.endtime_bills" type="date" value-format="yyyy-MM-dd" clearable>
	                            </el-date-picker>
	                        </td>
	                    </tr> -->
						</table>
						<el-button class="green_btn" @click="particulars_goods_in">引用</el-button>
						<el-button class="green_btn" @click="particulars_goods_search">查询</el-button>
					</div>
				</el-col>
			</el-row>
		</el-dialog>
		<examineImg ref="examineImg" v-on:stockTypeTxtSave="stockTypeTxtSave" v-on:cutImg="cutImg"></examineImg>
	</div>
</template>
<script>
import { ElMessage, ElMessageBox, ElLoading } from 'element-plus'
import { shallowRef } from 'vue'
import examineImg from '../public/imgPublish';
export default {
	components: {
		examineImg
	},
	data() {

		return {
			is_import_list: [
				{ text: 'APP', value: '1' },
				{ text: 'ERP', value: '2' },
				{ text: 'PC新建', value: '3' },
				{ text: '文档导入', value: '0' },
			],
			stocktype_list: [{
				id: 'A',
				name: '滞纳、在保、包附完好'
			},
			{
				id: 'B',
				name: '滞纳、在保、包附破损'
			},
			{
				id: 'C',
				name: '滞纳、过保、包附完好'
			},
			{
				id: 'D',
				name: '滞纳、过保、包附破损'
			},
			{
				id: 'E',
				name: '二手、在保、包附完好'
			},
			{
				id: 'F',
				name: '二手、在保、包附破损'
			},
			{
				id: 'G',
				name: '二手、过保、包附完好'
			},
			{
				id: 'H',
				name: '二手、过保、包附破损'
			}
			],
			search_val: {},
			goods_data: {},
			particulars_goods_tableData: [],
			dialogTableVisible_goods: false,
			particulars_goods_loading: false,
			particulars_goods_total: 0,
			particulars_goods_page: 1,
			particulars_goods_page_size: 120,
			cccc: [
				{ id: 1, name: "张三" }, // 字段名是 id 和 name
			],
			columns: [
				{ key: 'id', title: 'ID', width: 100, length: 20 },
				{ key: 'name', title: '姓名', width: 120, cellRenderer: ({ rowData }) => rowData.name || '暂无数据' },
				{ key: 'age', title: '年龄', width: 100 }
			],
			row_input: '', // 当前输入的输入框位置
			index_id: '',
			tabClickIndex: '', // 
			tabClickLabel: '', //
			tabClickcolumn: '', //
			particulars_goods_index: [],
			SelectionChangeId: [],
			particulars_form: { difference: 2 },
			differenceList: [{ id: 1, name: '无差异' }, { id: 2, name: '有差异' }],
			particulars_total: 0,
			particulars_page: 1,
			particulars_page_size: 120,
			particulars_tableData: [],
			dialogTableVisible: false,
			particulars_loading: false,
			total: 0,
			page: 1,
			page_size: 120,
			form: { is_show: '' },
			tableHeight: null,
			showLeadin: false,
			no_loading: false,
			loading: false,
			showLeadin_table: false,
			input3: '',
			fileList: [],
			no_tableData: [],
			save_tableList: [],
			tableData: shallowRef([]),
			checkonestorage: {},
			index: [],

		}
	},
	props: ['activeName'],

	updated() {

	},
	beforeUnmount() {
		document.removeEventListener('click', this.handleClickOutside);
	},
	mounted() {
		document.addEventListener('click', this.handleClickOutside);
		this.$nextTick(() => {
			var obj = this;
			document.addEventListener('keyup', function (e) {
				if (obj.tabClickIndex !== '' && obj.tabClickcolumn !== '' && obj.activeName == "publish") {
					if (e.keyCode == 40) { //下

						//alert(obj.tabClickIndex)
						obj.key_cut(1);
					} else if (e.keyCode == 38) { //上
						//alert(obj.tabClickIndex)
						obj.key_cut(2);
					}
				}
			});
			/*document.onkeyup = function(e) {
				console.log(obj.tabClickIndex , obj.tabClickcolumn,1111)
				


			}*/
		})
	},

	activated() {

	},
	created() {
		this.path = this.$route.path.split('/')[1];
		this.user_id = localStorage.getItem('user_id');
		//查询当前页面的分页
		var page = JSON.parse(localStorage.getItem('page'));
		page = page ? page : {};
		var name = this.user_id + this.$route.path.split('/')[1];
		if (page[name]) {
			this.page_size = page[name];
		} else {
			this.page_size = 120;
			page[name] = this.page_size
			localStorage.setItem('page', JSON.stringify(page))
		}
		this.getcheckonestorage();
		this.tableHeight_fun();
		this.search()
	},
	watch: {

	},
	methods: {
		getId(row) {
			if (row.id) {
				//console.log(row)
				return row.id;
			} else {
				//console.log(row)
				return row.key + 'id';
			}
		},
		handleClickOutside(event) {
			// 检查点击是否发生在表格外部
			/*if (this.$refs.singleTable && !this.$refs.singleTable.$el.contains(event.target)) {
				console.log('点击了表格外部区域');
				// 在这里添加你的处理逻辑
				this.row_input = ''; // 当前输入的输入框位置
				this.index_id = '';
				this.tabClickIndex = ''; // 
				this.tabClickLabel = ''; //
				this.tabClickcolumn = ''; //
				this.index=[];
			}*/
		},
		ps_input() {
			this.page_size = this.page_size > 200 ? 200 : this.page_size
			var page_size = this.page_size;

			var name = this.user_id + this.$route.path.split('/')[1];
			var page = JSON.parse(localStorage.getItem('page'));
			page[name] = this.page_size
			localStorage.setItem('page', JSON.stringify(page))
		},
		onSubmit() {

		},
		search() {

		},
		newBuild() {
			this.row_input = ''; // 当前输入的输入框位置
			this.index_id = '';
			this.tabClickIndex = ''; // 
			this.tabClickLabel = ''; //
			this.tabClickcolumn = ''; //
			this.index = [];
			if (this.tableData.length > 0) {
				var key = Math.max.apply(Math, this.tableData.map(item => { return item.key }))
			} else {
				var key = 0;
			}
			var data = {
				key: key + 1,
				img: [],
				brand_name: '',
				name: '',
				model: '',
				order_no: '',
				num: '',
				price: '',
				discount: '',
				real_price: '',
				real_money: '',
				goods_shelf: '',
				stock_type_txt: '滞纳、在保、包附完好',
				is_import: 3,
			}
			this.tableData.unshift(data)
			this.tableData = JSON.parse(JSON.stringify(this.tableData));
			this.facePriceblur('', data)

		},
		async updatestorage() {
			if (!this.save_tableList.length) {
				return ElMessage({
					message: '请先修改数据！',
					type: 'error',
					grouping: true // 开启合并功能
				})
			}
			var data = [];

			this.save_tableList.forEach(function (item, index) {
				data.push(item)
			})
			this.loading = true
			await this.$axios.post('/api/yunsys.storage/updateinfo', { date: data }).then(async (res) => {
				var res = res.data;
				this.loading = false
				if (res.code !== 0) {
					return ElMessage({
						message: res.msg,
						type: 'error',
						grouping: true // 开启合并功能
					})
				}
				this.save_tableList = [];
				this.search()
				return ElMessage({
					message: res.msg,
					type: 'success',
					grouping: true // 开启合并功能
				})

			})
				.catch(err => {
					this.loading = false
					return ElMessage({
						message: '系统错误',
						type: 'error',
						grouping: true // 开启合并功能

					})
				})
		},
		inputBlur_price(index, v, row) { //列表价改变
			row.price = this.clearNoNum(v, 2)
			row.real_price = this.$bn.multiply(row.price, row.discount, 2)
			row.real_money = this.$bn.multiply(row.real_price, row.num, 2);
		},
		inputBlur_real_price(index, v, row) { //单价
			row.real_price = this.clearNoNum(v, 2)
			row.real_money = this.$bn.multiply(row.real_price, row.num, 2);
			row.discount = this.$bn.divide(row.real_price, row.price, 3);


		},
		inputBlur_discount(index, v, row) { //折扣改变
			row.discount = this.clearNoNum(v, 3)
			row.real_price = this.$bn.multiply(row.price, row.discount, 2)
			row.real_money = this.$bn.multiply(row.real_price, row.num, 2);
			/*row.tsw_discount = this.$bn.multiply(row.tsw_price,row.price, 3);*/


		},
		inputBlur_num(index, v, row) { //数量改变
			row.num = this.clearNoNum(v, 1)
			row.real_money = this.$bn.multiply(row.real_price, row.num, 2);


		},
		inputfocus(index, e) {
			this.row_input = index
			if (e.target.select) {
				e.target.select()
			}
		},
		updateStorckType(v, row, index) {
			//console.log(v, row, index)
			this.facePriceblur('', row)
		},
		facePriceblur(v, row, index, name) {
			//console.log(row.key,112222)
			if (name == "num") {
				row[name] = this.$bn.multiply(row[name], 1, 0)
			} else if (name == "discount") {
				row[name] = this.$bn.multiply(row[name], 1, 3)
			} else if (name == "real_price") {
				row[name] = this.$bn.multiply(row[name], 1, 2)
			} else if (name == "price") {
				row[name] = this.$bn.multiply(row[name], 1, 2)
			}
			if (this.save_tableList.length > 0) {
				var obj = this
				var info = 0;
				//20250813 加了新增行的功能 没有id 用key处理下
				this.save_tableList.forEach(function (item, index) {
					if (row.id == item.id && typeof item.id != "undefined") {
						item = row;
						info = 1;
					} else if (row.key == item.key) {
						//console.log(row,333333)
						obj.save_tableList[index] = row;
						info = 1;
					}
				})
				if (info === 0) {
					this.save_tableList.push(row);
				}
			} else {
				this.save_tableList.push(row);
			}
			//console.log(this.save_tableList,111111111)
		},
		tableRowClassName({
			row,
			rowIndex
		}) {
			row.index = rowIndex
			return ''
		},
		clearNoNum(value, decimals) {
			//先把非数字的都替换掉，除了数字和. 
			value = value.replace(/[^\d.]/g, "");
			//保证只有出现一个.而没有多个. 
			value = value.replace(/\.{2,}/g, ".");
			//必须保证第一个为数字而不是. 
			value = value.replace(/^\./g, "");
			//保证.只出现一次，而不能出现两次以上 
			value = value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
			//只能输入四个小数 (\d\d\d\d)
			return value.replace(eval("/^(\\-)*(\\d+)\\.(\\d{1," + decimals + "}).*$/"), '$1$2.$3')

		},
		convertStatusToHtml(txt) {
			// 边界值处理：空值/非字符串直接返回空
			if (!txt || typeof txt !== 'string') return '';

			// 核心：将字符串按【全角/半角逗号】分割为数组，同时去除每个项的空格、过滤空值
			// 比如 "滞纳、在保、包附完好" → ["滞纳", "在保", "包附完好"]
			const statusArr = txt
				.split(/[、,，]/) // 按全角/半角逗号分割
				.map(item => item.trim()) // 去除每个项的首尾空格
				.filter(item => item); // 过滤分割后可能出现的空字符串

			//console.log('分割后的数组：', statusArr); // 调试：确认数组正确生成

			// 组装HTML片段
			const htmlParts = [];
			statusArr.forEach(status => {
				if (status === '二手' || status === '包附破损' || status === '过保') {
					// 二手单独加红色样式
					htmlParts.push(`<span style="color:red" class="">${status}</span>`);
				} else {
					// 其他状态默认样式
					htmlParts.push(`<span class="">${status}</span>`);
				}
			});

			// 用顿号拼接所有span，返回最终HTML字符串
			return htmlParts.join('、');
		},
		key_cut(info) {
			var tabClickIndex = '';
			var obj = this;
			if (info == 1) { //下
				var type = 1;
				this.tableData.forEach(function (item, index) {
					if (index > obj.tabClickIndex && item.is_import != 2 && type) {
						tabClickIndex = index;
						type = 0;
					}
				})

			} else { // 上
				this.tableData.forEach(function (item, index) {
					if (index < obj.tabClickIndex && item.is_import != 2) {
						tabClickIndex = index;
					}
				})
			}

			if (tabClickIndex !== '') {
				/*var name = '';
				if (this.tabClickcolumn == 1) {
					name = "discount"
					this.tableData[this.tabClickIndex][name] = this.$bn.multiply(this.tableData[this.tabClickIndex][name], 1, 0)
				} else if (this.tabClickcolumn == 2) {
					name = "real_price"
					this.tableData[this.tabClickIndex][name] = this.$bn.multiply(this.tableData[this.tabClickIndex][name], 1, 0)
				} else if (this.tabClickcolumn == 3) {
					name = "num"
				} else if (this.tabClickcolumn == 8) {
					name = "price"
				}*/
				this.facePriceblur('', this.tableData[this.tabClickIndex]);
				this.tabClickIndex = tabClickIndex
				if (this.tabClickcolumn != 9) {
					this.$nextTick(() => {
						document.getElementById('save_input' + parseInt(tabClickIndex) + this.tabClickcolumn).focus()

					})

				}

			}

		},
		tabClick(row, column, cell, event) {
			var c;
			row.index = parseInt(row.index)
			if (row.is_import == 2 && column.label != '货物状态' && column.label != '备注') {
				this.tabClickIndex = ''
				this.tabClickLabel = ''
				this.tabClickcolumn = ''
				return false
			}
			switch (column.label) {
				// case '折扣':
				// 	this.tabClickIndex = row.index
				// 	this.tabClickLabel = column.label
				// 	this.tabClickcolumn = 1
				// 	c = 1
				// 	break
				case '预入单价':
					this.tabClickIndex = row.index
					this.tabClickLabel = column.label
					this.tabClickcolumn = 2
					c = 1
					break
				case '*数量':
					this.tabClickIndex = row.index
					this.tabClickLabel = column.label
					this.tabClickcolumn = 3
					c = 1
					break
				case '*品牌':
					this.tabClickIndex = row.index
					this.tabClickLabel = column.label
					this.tabClickcolumn = 4
					c = 1
					break
				case '品名':
					this.tabClickIndex = row.index
					this.tabClickLabel = column.label
					this.tabClickcolumn = 5
					c = 1
					break
				case '*型号':
					this.tabClickIndex = row.index
					this.tabClickLabel = column.label
					this.tabClickcolumn = 6
					c = 1
					break
				case '订货号':
					this.tabClickIndex = row.index
					this.tabClickLabel = column.label
					this.tabClickcolumn = 7
					c = 1
					break
				// case '列表价':
				// 	this.tabClickIndex = row.index
				// 	this.tabClickLabel = column.label
				// 	this.tabClickcolumn = 8
				// 	c = 1
				// 	break
				case '*货物状态':
					this.tabClickIndex = row.index
					this.tabClickLabel = column.label
					this.tabClickcolumn = 9
					c = 2
					break
				case '货架':
					this.tabClickIndex = row.index
					this.tabClickLabel = column.label
					this.tabClickcolumn = 10
					c = 1
					break
				case '备注':
					this.tabClickIndex = row.index
					this.tabClickLabel = column.label
					this.tabClickcolumn = 11
					c = 1
					break
				default:
					return
			}

			if (c == 1) {
				this.$nextTick(() => {
					document.getElementById('save_input' + parseInt(row.index) + this.tabClickcolumn).focus()
				})
			}


		},
		particulars_goods_in() {
			if (this.particulars_goods_index.length > 0) {
				this.tableData[this.goods_data['index']]['brand_name'] = this.particulars_goods_tableData[this.particulars_goods_index[0]].brand_name
				this.tableData[this.goods_data['index']]['name'] = this.particulars_goods_tableData[this.particulars_goods_index[0]].name
				this.tableData[this.goods_data['index']]['model'] = this.particulars_goods_tableData[this.particulars_goods_index[0]].model
				this.tableData[this.goods_data['index']]['order_no'] = this.particulars_goods_tableData[this.particulars_goods_index[0]].order_no
				this.tableData[this.goods_data['index']]['price'] = this.particulars_goods_tableData[this.particulars_goods_index[0]].price
				this.tableData[this.goods_data['index']]['series'] = this.particulars_goods_tableData[this.particulars_goods_index[0]].series;
				this.tableData[this.goods_data['index']].real_price = this.$bn.multiply(this.tableData[this.goods_data['index']].price, this.tableData[this.goods_data['index']].discount, 2)
				this.tableData[this.goods_data['index']].real_money = this.$bn.multiply(this.tableData[this.goods_data['index']].real_price, this.tableData[this.goods_data['index']].num, 2);
				this.dialogTableVisible_goods = false;
				this.facePriceblur('', this.tableData[this.goods_data['index']])
				this.tableData = JSON.parse(JSON.stringify(this.tableData))
			} else {
				return ElMessage({
					message: '请选择数据！',
					type: 'error',
					grouping: true // 开启合并功能
				})
			}
		},
		rowDblclickGoods(row) {
			this.dialogTableVisible_goods = false;
			this.tableData[this.goods_data['index']]['brand_name'] = row.brand_name
			this.tableData[this.goods_data['index']]['name'] = row.name
			this.tableData[this.goods_data['index']]['model'] = row.model
			this.tableData[this.goods_data['index']]['order_no'] = row.order_no
			this.tableData[this.goods_data['index']]['price'] = row.price
			this.tableData[this.goods_data['index']]['series'] = row.series;
			this.tableData[this.goods_data['index']].real_price = this.$bn.multiply(this.tableData[this.goods_data['index']].price, this.tableData[this.goods_data['index']].discount, 2)
			this.tableData[this.goods_data['index']].real_money = this.$bn.multiply(this.tableData[this.goods_data['index']].real_price, this.tableData[this.goods_data['index']].num, 2);

			this.facePriceblur('', this.tableData[this.goods_data['index']])
			this.tableData = JSON.parse(JSON.stringify(this.tableData))
		},
		particulars_goods_tableRowClassName({
			row,
			rowIndex
		}) {
			row.index = rowIndex
			return ''
		},
		particulars_goods_addStyle({ row, rowIndex }) {
			if (this.particulars_goods_index.indexOf(rowIndex) > -1) {
				return { 'background-color': '#ecf5ff' }
			}
		},
		particulars_goods_rowClick(row, column, e) {
			this.particulars_goods_index = [parseInt(row.index)]
		},
		rowClick(row, column, e) {
			this.tabClickIndex = parseInt(row.index)
			this.index = [parseInt(row.index)] //选中行this.tabClickcolumn = 1
			this.$refs.singleTable.setCurrentRow(this.tableData[parseInt(row.index)]);
		},
		del() {
			if (this.SelectionChangeId.length > 0) {
				ElMessageBox.confirm(
					'确认删除此数据，不可恢复！',
					'提示', {
					confirmButtonText: '确认',
					cancelButtonText: '取消',
					type: 'warning',
				}
				)
					.then(() => {
						this.del_ajax()
					})
					.catch(() => {

					})
			} else {
				return ElMessage({
					message: '请先选中数据！',
					type: 'error',
					grouping: true // 开启合并功能
				})
			}

		},
		async del_ajax() {
			this.loading = true
			await this.$axios.post('/api/yunsys.storage/deletestorage', { ids: this.SelectionChangeId }).then(async (res) => {
				var res = res.data;
				this.loading = false
				if (res.code !== 0) {
					return ElMessage({
						message: res.msg,
						type: 'error',
						grouping: true // 开启合并功能
					})
				}
				this.page = 1;
				this.search()
				this.$emit('pcsummary', {});
				this.getcheckonestorage();
				return ElMessage({
					message: res.msg,
					type: 'success',
					grouping: true // 开启合并功能
				})

			})
				.catch(err => {
					this.loading = false
					return ElMessage({
						message: '系统错误',
						type: 'error',
						grouping: true // 开启合并功能

					})
				})
		},
		//完善
		circulation() {
			if (this.SelectionChangeId.length > 0) {

				ElMessageBox.confirm(
					'确认转定价数据！',
					'提示', {
					confirmButtonText: '确认',
					cancelButtonText: '取消',
					type: 'warning',
				}
				)
					.then(() => {
						this.circulation_ajax();
					})
					.catch(() => {

					})
			} else {
				return ElMessage({
					message: '请先选中数据！',
					type: 'error',
					grouping: true // 开启合并功能
				})
			}
		},
		async circulation_ajax() {
			this.loading = true
			await this.$axios.post('/api/yunsys.storage/checkcirstorage', { ids: this.SelectionChangeId }).then(async (res) => {
				var res = res.data;
				this.loading = false
				if (res.code !== 0) {
					if (res.code == 2) {
						console.log(this.tableData[res.key], 1111)
						this.rowClick(this.tableData[res.key])
						return ElMessage({
							message: res.msg,
							type: 'error',
							grouping: true // 开启合并功能
						})
					}
					return ElMessage({
						message: res.msg,
						type: 'error',
						grouping: true // 开启合并功能
					})
				}
				this.page = 1;
				this.search()
				this.$emit('pcsummary', {});
				this.getcheckonestorage();
				return ElMessage({
					message: res.msg,
					type: 'success',
					grouping: true // 开启合并功能
				})

			})
				.catch(err => {
					this.loading = false
					return ElMessage({
						message: '系统错误',
						type: 'error',
						grouping: true // 开启合并功能

					})
				})
		},
		handleSelectionChange(data) {
			var ids = [];
			data.forEach(function (item) {
				ids.push(item.id);
			})
			this.SelectionChangeId = ids
		},
		change_particulars_search() {
			this.particulars_tableData = []
			this.particulars_page = 1;
			this.particulars_search();
		},
		particulars_handleCurrentChange(val) {
			this.particulars_page = val;
			this.particulars_search();
		},
		empty() {
			this.search_val = {};
		},
		particulars_goods_handleCurrentChange(val) {
			this.particulars_goods_page = val;
			this.particulars_goods_search();
		},
		dialogTableVisible_goods_show(row) {
			this.dialogTableVisible_goods = true;
			this.goods_data = row;
			this.particulars_goods_page = 1
			this.particulars_goods_search()
		},

		async particulars_goods_search() {
			this.particulars_goods_index = [];
			this.particulars_goods_loading = true
			var search = this.search_val;
			search.page = this.particulars_goods_page;
			search.ps = this.particulars_goods_page_size;
			await this.$axios.post('/api/yunsys.storage/getbaseproductprice', search).then(async (res) => {
				var res = res.data;
				this.particulars_goods_loading = false
				if (res.code !== 0) {
					return ElMessage({
						message: res.msg,
						type: 'error',
						grouping: true // 开启合并功能
					})
				}
				var obj = this;
				this.particulars_goods_total = res.data.total;
				var key = 0;
				res.data.data.forEach(item => {
					key = key + 1

				})
				this.particulars_goods_tableData = res.data.data;

			})
				.catch(err => {
					this.particulars_goods_loading = false
					return ElMessage({
						message: '系统错误',
						type: 'error',
						grouping: true // 开启合并功能

					})
				})
		},
		async particulars_search() {
			this.particulars_loading = true
			var search = this.particulars_form;
			search.page = this.particulars_page;
			search.ps = this.particulars_page_size;
			search.id = this.checkonestorage.id;
			await this.$axios.post('/api/yunsys.storage/differstorage', search).then(async (res) => {
				var res = res.data;
				this.particulars_loading = false
				if (res.code !== 0) {
					return ElMessage({
						message: res.msg,
						type: 'error',
						grouping: true // 开启合并功能
					})
				}
				var obj = this;
				this.particulars_total = res.data.total;
				var key = 0;
				res.data.data.forEach(item => {
					key = key + 1
					item.original_price = obj.$bn.multiply(item.original_price, 1, 2);
					item.original_real_price = obj.$bn.multiply(item.original_real_price, 1, 2);
					item.original_real_money = obj.$bn.multiply(item.original_real_money, 1, 2);
					item.original_discount = obj.$bn.multiply(item.original_discount, 1, 3);

					item.present_price = obj.$bn.multiply(item.present_price, 1, 2);
					item.present_real_price = obj.$bn.multiply(item.present_real_price, 1, 2);
					item.present_real_money = obj.$bn.multiply(item.present_real_money, 1, 2);
					item.present_discount = obj.$bn.multiply(item.present_discount, 1, 3);
				})
				this.particulars_tableData = res.data.data;

			})
				.catch(err => {
					this.particulars_loading = false
					return ElMessage({
						message: '系统错误',
						type: 'error',
						grouping: true // 开启合并功能

					})
				})
		},
		stockTypeTxtSave(val) {
			this.tableData[this.index[0]]['stock_type_txt'] = val.stock_type_txt;
			this.tableData[this.index[0]]['associate'] = val.associate;
			this.tableData = JSON.parse(JSON.stringify(this.tableData))
			//console.log(val,112121)
		},
		cutImg(index, info, del) { //1 上 2 下1
			//删除数据
			if (del) {
				this.tableData = this.tableData.filter(item => index !== item.index);
			}
			if (index < 0) {
				return ElMessage({
					message: '无上一个产品',
					type: 'error',
					grouping: true // 开启合并功能

				})
			} else if (this.tableData[index]) {
				this.tabClickIndex = parseInt(index)
				this.index = [parseInt(index)] //选中行this.tabClickcolumn = 1
				this.$refs.singleTable.setCurrentRow(this.tableData[parseInt(index)]);
				this.preview(this.tableData[index], this.tableData[index]['img'])
			} else {
				return ElMessage({
					message: '无下一个产品',
					type: 'error',
					grouping: true // 开启合并功能

				})
			}
		},
		preview(row, img) {
			this.srcList = [];
			/*this.srcList_index = 0
			this.showPreview = true;*/
			var obj = this;
			img.forEach(function (item) {
				obj.srcList.push(item)
			})
			this.$refs['examineImg'].img_title = JSON.parse(JSON.stringify(row));
			this.$refs['examineImg'].select_info = true;
			this.$refs['examineImg'].share_info = false;
			this.$refs['examineImg'].cutImg_info = true;
			this.$refs['examineImg'].data = this.srcList;
			this.$refs['examineImg'].dialogTableVisible = true;
			this.$refs['examineImg'].imgBigUrl = this.srcList[0];
		},
		addStyle({ row, rowIndex }) {
			if (this.index.indexOf(rowIndex) > -1) {
				return { 'background-color': 'rgba(255, 138, 92, 0.6)' }
			} else if (row.is_import == 2) {
				return { 'background-color': 'rgb(246, 248, 251)' }
			} else {

			} /**/
		},

		async handleRequest(file) {
			const params = file.file
			const form = new FormData()
			form.append('pro_list', params)
			const loadingInstance = ElLoading.service({ fullscreen: true, target: document.querySelector('.plrkDialog .m0') })
			await this.$axios.post('/api/yunsys.storage/addimport', form, { headers: { 'Content-type': 'multipart/form-data' } }).then(async (res) => {
				var res = res.data;
				this.showLeadin = false
				loadingInstance.close();
				if (res.data.products.length > 0) {
					this.showLeadin_table = true;
					this.no_tableData = res.data.products
				}
				if (res.code !== 0) {
					return ElMessage({
						message: res.msg,
						type: 'error',
						grouping: true // 开启合并功能
					})
				}
				var obj = this;
				this.page = 1;
				this.search()
				this.$emit('pcsummary', {});
				return ElMessage({
					message: res.msg,
					type: 'success',
					grouping: true // 开启合并功能

				})

			})
				.catch(err => {
					this.showLeadin = false
					return ElMessage({
						message: '系统错误',
						type: 'error',
						grouping: true // 开启合并功能

					})
				})
			/*const { data: res } = await this.$http.post('/api/yunsys.baseproduct/addimport', form, { headers: { 'Content-type': 'multipart/form-data' } })*/

			/*if (res.code !== 0) {
				//return this.$message.error(res.msg)
			} else {
				this.showLeadin = false;
				//return this.$message.success(res.msg)
			}*/
		},
		showLeadin_click() {
			this.showLeadin = true;
		},
		grabble() {
			this.page = 1;
			this.save_tableList = [];
			this.search();
			this.getcheckonestorage();
			this.$emit('pcsummary', {});
		},
		tableHeight_fun() {
			this.$nextTick(() => {
				this.tableHeight = window.innerHeight - this.$refs.height_top.getBoundingClientRect().top - 100
			})
		},
		cert_addr() {
			window.open(this.$axios.defaults.baseURL + '/yunsys/download?name=products', '_blank')
		},
		handleCurrentChange(val) {
			this.page = val;
			this.search();
		},
		particulars() {
			this.dialogTableVisible = true;
			this.$nextTick(() => {
				this.particulars_search()
			})
		},
		//点击校对
		checkstorage() {
			if (this.checkonestorage.id) {
				if (this.checkonestorage.state === 0) { //第一次点击
					ElMessageBox.confirm(
						'确认校对数据！',
						'提示', {
						confirmButtonText: '确认',
						cancelButtonText: '取消',
						type: 'warning',
					}
					)
						.then(() => {
							this.checkstorage_ajax()
						})
						.catch(() => {

						})
				} else { //已经点击过  直接打开详情
					this.particulars()
				}
			} else {
				return ElMessage({
					message: '请先推送数据！',
					type: 'error',
					grouping: true // 开启合并功能

				})
			}


		},
		async checkstorage_ajax() {
			this.loading = true
			await this.$axios.post('/api/yunsys.storage/checkstorage', { id: this.checkonestorage.id }).then(async (res) => {
				var res = res.data;
				this.loading = false
				if (res.code !== 0) {
					return ElMessage({
						message: res.msg,
						type: 'error',
						grouping: true // 开启合并功能
					})
				}
				this.page = 1;
				this.$emit('pcsummary', {});
				this.search()
				this.getcheckonestorage();
				return ElMessage({
					message: res.msg,
					type: 'success',
					grouping: true // 开启合并功能
				})

			})
				.catch(err => {
					this.loading = false
					return ElMessage({
						message: '系统错误',
						type: 'error',
						grouping: true // 开启合并功能

					})
				})
		},
		async getcheckonestorage() {
			await this.$axios.post('/api/yunsys.storage/getcheckonestorage').then(async (res) => {
				var res = res.data;
				if (res.code !== 0) { }

				this.checkonestorage = res.data;

			})
				.catch(err => {

				})
		},
		selectable(row, index) {
			return row.is_show !== 1;
		},
		filterHandler(filters) {
			if (typeof filters.img != "undefined") {
				this.form.img = filters.img;
			}
			if (typeof filters.is_import != "undefined") {
				this.form.is_import = filters.is_import;
			}
			if (typeof filters.stock_type_txt != "undefined") {
				this.form.stock_type_txt = filters.stock_type_txt;
			}
			this.page = 1;
			//console.log(this.form,11111)
			this.search();
		},
		async search() {
			this.row_input = ''; // 当前输入的输入框位置
			this.index_id = '';
			this.tabClickIndex = ''; // 
			this.tabClickLabel = ''; //
			this.tabClickcolumn = ''; //
			this.index = [];
			this.save_tableList = [];
			this.loading = true
			var search = JSON.parse(JSON.stringify(this.form));
			if (typeof search.stock_type_txt === 'string') {
				search.stock_type_txt = [search.stock_type_txt]
			}
			if (typeof search.is_import === 'string') {
				search.is_import = [search.is_import]
			}
			search.page = this.page;
			search.ps = this.page_size;
			await this.$axios.post('/api/yunsys.storage/getownnostorage', search).then(async (res) => {
				var res = res.data;
				this.loading = false
				if (res.code !== 0) {
					return ElMessage({
						message: res.msg,
						type: 'error',
						grouping: true // 开启合并功能
					})
				}
				var obj = this;
				this.total = res.data.total;
				var key = 0;
				res.data.data.forEach(item => {
					key = key + 1
					item.key = (obj.page - 1) * 120 + key
					item.discount = obj.$bn.multiply(item.discount, 1, 3);
					item.real_price = obj.$bn.multiply(item.real_price, 1, 2);
					item.real_money = obj.$bn.multiply(item.real_money, 1, 2);
					/*item.tsw_money = obj.$bn.multiply(item.tsw_money, 1, 2);
					item.discount = obj.$bn.multiply(item.discount, 1, 3);*/
					//item.discount_calculate = obj.$bn.divide(item.real_price, item.price, 4)
				})
				this.tableData = res.data.data;

			})
				.catch(err => {
					this.loading = false
					return ElMessage({
						message: '系统错误',
						type: 'error',
						grouping: true // 开启合并功能

					})
				})
		},
	}
}
</script>
<style lang="less" scoped>
:deep(.el-input-group__append) {
	background: #ff8a5c;
}

:deep(.el-tooltip:has(.el-select)) {
	padding: 0rem;
}

:deep(.el-select__wrapper) {
	padding: 0.25rem 0.5rem;
	font-size: var(--el-font-size-extra-small);
}

:deep(.singleTable .el-table__body tr td:nth-child(n+9):nth-child(-n+10)) {
	border-top: 2px solid #dadada;
	border-right: 2px solid #dadada;
}

:deep(.singleTable .el-table__body tr:last-child td:nth-child(n+9):nth-child(-n+10)) {
	border-bottom: 2px solid #dadada !important;
	position: relative;
	z-index: 1900;
}



:deep(.singleTable .el-table__body tr td:nth-child(9)) {
	border-left: 2px solid #dadada;
}



:deep(.singleTable .el-table__body tr td:nth-child(n+7):nth-child(-n+7)) {
	border-top: 2px solid #dadada;
	border-right: 2px solid #dadada;
}

:deep(.singleTable .el-table__body tr:last-child td:nth-child(n+7):nth-child(-n+7)) {
	border-bottom: 2px solid #dadada !important;
	position: relative;
	z-index: 1900;
}

/* 按钮列的响应式对齐样式 */
.btn-col-responsive-align {
	/* 先统一清除原有内联样式，避免冲突 */
	margin: 0;
	padding: 0;
}

/* 1. 超小屏（xs：< 768px，对应 :xs="24"）- 靠左对齐 */
@media (max-width: 767px) {
	.btn-col-responsive-align {
		text-align: left;
	}
}

/* 2. 小屏（sm：768px ~ 991px，对应 :sm="12"）- 靠左对齐 */
@media (min-width: 768px) and (max-width: 991px) {
	.btn-col-responsive-align {
		text-align: left;
	}
}

/* 3. 中等屏及以上（md/lg/xl：≥ 992px）- 靠右对齐 */
@media (min-width: 992px) {
	.btn-col-responsive-align {
		text-align: right;
	}
}

:deep(.singleTable .el-table__body tr td:nth-child(7)) {
	border-left: 2px solid #dadada;
}

:deep(.el-table .el-input__wrapper) {
	height: 1.5rem;
	// --el-input-inner-height: calc(var(--el-input-height, 32px) - 0.425rem);
}

:deep(.el-table .el-select__wrapper) {
	/* line-height: 1.5rem;
  min-height: 1.5rem;
  padding: 0.40rem 0.5rem;
  */
}

:deep(.plrkDialog) {
	width: 600px;
	height: 290px;

	.el-upload {
		text-align: left;
	}

	:deep(.el-upload:focus) {
		color: #333;
	}
}
</style>